export const HR_MAX = 9;
export const HR_EXP_THRESHOLDS = [
  0, 100, 260, 500, 850, 1300, 1900, 2700, 3800,
] as const;
export function hrForExp(exp: number): number {
  let hr = 1;
  for (let i = 1; i < HR_EXP_THRESHOLDS.length; i++)
    if (exp >= HR_EXP_THRESHOLDS[i]) hr = i + 1;
  return Math.min(HR_MAX, hr);
}
export function settleHunterRank(
  currentHr: number,
  currentExp: number,
  gained: number,
) {
  const hrExp = Math.max(0, currentExp + gained);
  return {
    hrExp,
    hrBefore: currentHr,
    hrAfter: Math.max(currentHr, hrForExp(hrExp)),
    promoted: hrForExp(hrExp) > currentHr,
  };
}
export function canAcceptStar(hr: number, star: number) {
  return star >= 1 && star <= Math.min(HR_MAX, hr);
}
export const THREAT_DESCRIPTIONS = [
  "草食种与基础采集",
  "小型怪物群",
  "大型鸟龙与初阶牙兽",
  "飞龙种入门威胁",
  "主力飞龙与牙龙",
  "高危大型怪物",
  "古龙级危险征兆",
  "极高危古龙级",
  "天灾级古龙",
] as const;
